import React from 'react';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';
import { I18n, Translate } from 'react-redux-i18n';
import activationApi from '../../../network/api/activationApi';
import { getLinks } from '../../../network/api/links';
import Button from '../../common/Button';
import logo from '../../../img/logo-idnot.png';
import Loader from '../../Loader';
import { CONNECTION_INFO_FORM, EMERGENCY_INFO_FORM } from '../../../routes';
import Footer from '../../layout/Footer';

enum Mode {
  ModeSuccess,
  ModeErrInvalidToken,
  ModeErrExpiredToken,
  ModeErrUserNotFound,
  ModeErrUnknowError,
  ModeWait
}

type Props = RouteComponentProps<{ key: string }>;
type State = {
  token: string,
  mode: Mode,
};

class VerificationModificationEmail extends React.Component<Props, State> {
  state: State = {
    token: this.props.match.params.key,
    mode: Mode.ModeWait,
  };

  componentDidMount() {
    this.validEmail();
  }

  isModeWait = ():boolean => this.state.mode === Mode.ModeWait;

  isModeSuccess = ():boolean => this.state.mode === Mode.ModeSuccess;

  isModeErrInvalidToken = ():boolean => this.state.mode === Mode.ModeErrInvalidToken;

  isModeErrExpiredToken = ():boolean => this.state.mode === Mode.ModeErrExpiredToken;

  isModeErrUserNotFound = ():boolean => this.state.mode === Mode.ModeErrUserNotFound;

  isModeErrUnknowError = ():boolean => this.state.mode === Mode.ModeErrUnknowError;

  validEmail = () => {
    activationApi.finish({
      key: this.state.token, password: '',
    }).then((data) => {
      this.setState({ mode: Mode.ModeSuccess });
    }).catch((err) => {
      if (typeof err.then === 'function') {
        return err.then((e) => {
          switch (e.fieldErrors[0].errorCode) {
            case 'ACTI_GP_01':
              this.setState({ mode: Mode.ModeErrInvalidToken });
              break;
            case 'ACTI_GP_02':
              this.setState({ mode: Mode.ModeErrExpiredToken });
              break;
            case 'ACTI_GP_04':
              this.setState({ mode: Mode.ModeErrUserNotFound });
              break;
            default:
              this.setState({ mode: Mode.ModeErrUnknowError });
              break;
          }
          window.scrollTo(0, 0);
        });
      }
      return null;
    });
  };

  render() {
    return (
      <div className="activation-link-page">
        <div className="activation-header">
          <div className="label-container">
            <div className="main-content">
              <div>
                <img className="logo" src={logo} alt="logo" />
              </div>
              <div>
                <h3>
                  <Translate value="ACTIVATION.TITLE" />
                </h3>
                <div className="subtitle">
                  <Translate value="HEADER.UNIQUE_ACCOUNT" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          this.isModeWait()
          && (
            <Loader />
          )
        }
        {
          this.isModeSuccess()
          && (
            <div className="email-page-content">
              <h3><Translate value="EMAIL_MODIFICATION.SUCCESS" /></h3>
              <div className="back-button">
                <Button
                  type="third"
                  i18nKey="HEADER.CONNECTION"
                  onClick={() => this.props.history.push(EMERGENCY_INFO_FORM)}
                />
              </div>
            </div>
          )
        }
        {
          (this.isModeErrInvalidToken()
            || this.isModeErrUserNotFound())
          && (
            <div className="email-page-content">
              <h3><Translate value="EMAIL_MODIFICATION.INVALID" /></h3>
              <Translate value="message.RETRY_PROCESS" />
            </div>
          )
        }
        {
          this.isModeErrExpiredToken()
          && (
            <div className="email-page-content">
              <h3><Translate value="EMAIL_MODIFICATION.EXPIRED" /></h3>
              <Translate value="message.RETRY_PROCESS" />
            </div>
          )
        }
        {
          this.isModeErrUnknowError()
          && (
            <div className="email-page-content">
              <h3><Translate value="EMAIL_MODIFICATION.UNKNOWN" /></h3>
              <Translate value="message.RETRY_PROCESS" />
            </div>
          )
        }
        {
          (this.isModeErrInvalidToken()
          || this.isModeErrUserNotFound()
          || this.isModeErrExpiredToken()
          || this.isModeErrUnknowError())
          && (
            <div className="email-page-content">
              <div className="back-button">
                <Button
                  type="third"
                  i18nKey="HEADER.CONNECTION"
                  onClick={() => this.props.history.push(EMERGENCY_INFO_FORM)}
                />
              </div>
            </div>
          )
        }
        <Footer />
      </div>
    );
  }
}
export default withRouter(VerificationModificationEmail);
